import { render } from "./MatchmakerCriteria.vue?vue&type=template&id=46e63c8a&scoped=true"
import script from "./MatchmakerCriteria.vue?vue&type=script&lang=js"
export * from "./MatchmakerCriteria.vue?vue&type=script&lang=js"

import "./MatchmakerCriteria.vue?vue&type=style&index=0&id=46e63c8a&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e63c8a"]])

export default __exports__